(function(sk, $){

	/*
		Widget Pager
		version 1

		Created:
		14.02.2012 | Michal Matuška (michal.matuska@superkoderi.cz)

		Updates:
		-

		Fixed bugs:
		-
	*/

	sk.widgets.Pager = function (options)
	{
		this.options = $.extend({
			// aktivní
			current: 0,
			// počet stránek
			max: 0,
			// krok
			step: 1,
			// nekonečné
			infinite: false,
			// ovládací prvek pro předchozí
			pagerPrev: null,
			// ovládací prvek pro další
			pagerNext: null,
			// vygenerovat menu pro kroky
			pagerPages: null,
			// maska kroků
			pagerMask: null,
			pagerMaskString: '{$active}/{$all}', // {$active} = aktivní položka, {$all} = celkový počet
			pagerMaskAdd: 1

		}, options);

		this.current = this.options.current;
		this.step = this.options.step;
		this.min = 0;
		this.max = this.options.max;
		this.infinite = this.options.infinite;
		this.isInit = false;

		return this;
	};

	// SHORTCUT
	//-

	// PROTOTYPE
	var _fn = sk.widgets.Pager.prototype;


	_fn.init = function()
	{
		/*if(!this.max)
		{
			return this;
		}*/

		var o = this.options;

		// předchozí
		if(o.pagerPrev)
		{
			this.$pagerPrev = o.pagerPrev.jquery ? o.pagerPrev : $(o.pagerPrev);

			this.$pagerPrev
				.bind('mousedown touchstart', $.proxy(this.handlePrev, this))
				.bind('click', $.proxy(this.handlePrevent, this));

			this.prevDisabled = false;
		}

		// další
		if(o.pagerNext)
		{
			this.$pagerNext = o.pagerNext.jquery ? o.pagerNext : $(o.pagerNext);

			this.$pagerNext
				.bind('mousedown touchstart', $.proxy(this.handleNext, this))
				.bind('click', $.proxy(this.handlePrevent, this));

			this.nextDisabled = false;
		}

		// stránky
		if(o.pagerPages)
		{
			this.$pagerPages = o.pagerPages.jquery ? o.pagerPages : $(o.pagerPages);
			this.pagerIsCreated = false;

			if( !this.$pagerPages.children().length )
			{
				this.pagerIsCreated = true;

				var pages = '';
				for(var i = 0; i <= this.max; i++)
				{
					pages += '<a href="#" data-sk-page-index="'+i+'"><span>'+ (i+1) +'</span></a>';
				}

				this.$pagerPages
					.append(pages)
			}

			this.$parerPagesItem = this.$pagerPages.find('a');
			this.$pagerPages
				.on('mousedown touchstart', 'a', $.proxy(this.handlePage, this))
				.on('click', 'a', $.proxy(this.handlePrevent, this));
		}

		// mask
		if(o.pagerMask)
		{
			this.$pagerMask = o.pagerMask.jquery ? o.pagerMask : $(o.pagerMask);
		}

		this.isInit = true;

		this.check();

		return this;
	};

	_fn.reinit = function()
	{
		this.check();
	};

	_fn.destroy = function()
	{
		var o = this.options;

		// odstraní
		if(typeof this.$pagerPrev != 'undefined')
		{
			this.$pagerPrev
				.unbind('mousedown touchstart', this.handlePrev)
				.unbind('click', this.handlePrevent);

			delete this.$pagerPrev;
			delete this.prevDisabled;
		}

		// další
		if(typeof this.$pagerNext != 'undefined')
		{
			this.$pagerNext
				.unbind('mousedown touchstart', this.handleNext)
				.unbind('click', this.handlePrevent);

			delete this.$pagerNext;
			delete this.nextDisabled;
		}

		// stránky
		if(typeof this.$pagerPages != 'undefined')
		{
			this.$pagerPages
				.undelegate('a', 'mousedown touchstart', this.handlePage)
				.undelegate('a', 'click', this.handlePrevent)

			if( this.pagerIsCreated )
			{
				this.$pagerPages
					.empty();
			}

			delete this.pagerIsCreated;
			delete this.$parerPagesItem;
			delete this.$pagerPages;
		}

		// mask
		if(typeof this.$pagerMask != 'undefined')
		{
			this.$pagerMask.empty();
			delete this.$pagerMask;
		}

		this.isInit = false;

		return this;
	};

	_fn.prev = function()
	{
		if( this.min != this.current || this.infinite )
		{
			var i = this.current - this.step;

			if(this.infinite)
			{
				this.current = (i + (this.max+1)) % (this.max+1);
			}
			else
			{
				this.current = (i < this.min) ? this.min : (i > this.max) ? this.max : i;
			}

			this.check();

			$(this).trigger('change', [{current: this.current, prev: true, next: false, page: false}]);
		}
	};

	_fn.next = function()
	{
		if( this.max != this.current || this.infinite )
		{
			var i = this.current + this.step;

			if(this.infinite)
			{
				this.current = i % (this.max+1);
			}
			else
			{
				this.current = (i < this.min) ? this.min : (i > this.max) ? this.max : i;
			}

			this.check();

			$(this).trigger('change', [{current: this.current, prev: false, next: true, page: false}]);
		}
	};

	_fn.page = function(i, noCall)
	{
		if( this.current !== i )
		{
			var i = (i < this.min) ? this.min : (i > this.max) ? this.max : i;

			this.current = i;
			this.check();

			if(!noCall)
			{
				$(this).trigger('change', [{current: this.current, prev: false, next: false, page: true}]);
			}
		}
	};



	_fn.check = function()
	{
		this.checkPrev();
		this.checkNext();
		this.checkPage();
		this.checkPagesMask();
	}

	// události
	_fn.handlePrev = function(e)
	{
		if(!this.prevDisabled)
		{
			this.prev();
			e.preventDefault();
		}
	};

	_fn.handleNext = function(e)
	{
		if(!this.nextDisabled)
		{
			this.next();
			e.preventDefault();
		}
	};

	_fn.handlePage = function(e)
	{
		this.page( this.$parerPagesItem.index(e.currentTarget) );
		e.preventDefault();
	};
	_fn.handlePrevent = function(e)
	{
		e.preventDefault();
	};

	// kontroly
	_fn.checkPrev = function(e)
	{
		if(typeof this.$pagerPrev != 'undefined')
		{
			if(!this.max)
			{
				this.$pagerPrev.addClass('off');
				this.prevDisabled = true;
				return;
			}
			else
			{
				this.$pagerPrev.removeClass('off');
			}

			if( this.min >= this.current && !this.infinite )
			{
				this.$pagerPrev.addClass('disabled');
				this.prevDisabled = true;
			}
			else if( this.prevDisabled )
			{
				this.$pagerPrev.removeClass('disabled');
				this.prevDisabled = false;
			}
		}
	};

	_fn.checkNext = function(e)
	{
		if(typeof this.$pagerNext != 'undefined')
		{
			if(!this.max)
			{
				this.$pagerNext.addClass('off');
				this.nextDisabled = true;
				return;
			}
			else
			{
				this.$pagerNext.removeClass('off');
			}

			if(this.max <= this.current && !this.infinite )
			{
				this.$pagerNext.addClass('disabled');
				this.nextDisabled = true;
			}
			else if( this.nextDisabled )
			{
				this.$pagerNext.removeClass('disabled');
				this.nextDisabled = false;
			}
		}
	};

	_fn.checkPage = function()
	{
		if(typeof this.$pagerPages != 'undefined')
		{
			this.$parerPagesItem
				.removeClass('active')
				.eq(this.current)
					.addClass('active');
		}
	};

	_fn.checkPagesMask = function()
	{
		if(typeof this.$pagerMask != 'undefined')
		{
			this.$pagerMask
				.html(this.options.pagerMaskString.replace('{$active}', this.current + this.options.pagerMaskAdd ).replace('{$all}', this.max + this.options.pagerMaskAdd));
		}
	};


})(sk, jQuery);


// WEBPACK FOOTER //
// ./src/js/class/sk.widgets.Pager.js